<template>
  <BaseTableView :head="tableHead" list-view="mdAndUp" :class="$vuetify.breakpoint.mdAndUp ? 'table' : ''">
    <tr v-for="(workType, key) in workTypeAllDone" :key="key">
      <td>{{ workType.name }}</td>
      <td>
        {{ workType.planned_work
        ? workType.is_hourly === 0
          ? $roundNumberToTenths(workType.planned_work) + ' ' + workType.measure
          : $formatTime(workType.planned_work)
        : '—' }}
      </td>
      <td>
        {{
          workType.is_hourly === 0
            ? $roundNumberToTenths(workType.done) + ' ' + workType.measure
            : $formatTime(workType.done)
        }}
      </td>
      <td>
        {{
          workType.planned_work - workType.done > 0 ?
            workType.is_hourly === 0
              ? $roundNumberToTenths(workType.planned_work - workType.done) + ' ' + workType.measure
              : $formatTime(workType.planned_work - workType.done)
            : '—'
        }}
      </td>
    </tr>
  </BaseTableView>
</template>

<script>
export default {
  name: 'TimeControlShowTableAllWork',
  props: ['periods'],
  data() {
    return {}
  },
  computed: {
    workTypeAllDone() {
      return this.onWorkTypeAllDone()
    },
    tableHead() {
      return [
        {text: this.localStorage.translations.pages.statistic_project.tables['vid-rabot']},
        {text: this.localStorage.translations.pages.statistic_project.tables['plan']},
        {text: this.localStorage.translations.pages.statistic_project.tables['fakt']},
        {text: this.localStorage.translations.pages.statistic_project.tables['k-vypolneniyu']}
      ]
    },
  },
  watch: {},
  mounted() {},
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    onWorkTypeAllDone() {
      let result = []
      console.log('periods', this.periods)
      for (let key in this.periods) {
        //console.log('key', key)
        let period = this.periods[key]
        //console.log('period', period)
        const findWorkType = (obj) => obj.id === period.work_type.id
        if (result.findIndex(findWorkType) === -1) {
          console.log('period', period)
          let obj = {
            id: period.work_type.id,
            name: period.work_type.name,
            done: period.done,
            measure: period.work_type.measure,
            is_hourly: period.work_type.is_hourly,
            planned_work: period.planned_work,
          }
          result.push(obj)
        } else {
          let objFind = result[result.findIndex(findWorkType)]
          objFind.done += period.done
        }
      }
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.table {
  :deep() td {
    &:nth-child(1) {
      width: 300px !important;
    }
    &:nth-child(2) {
      width: 100px !important;
    }
    &:nth-child(3) {
      width: 100px !important;
    }
    &:nth-child(4) {
      width: 100px !important;
    }
  }
}
</style>
